<svg width="120" height="121" viewBox="0 0 120 121" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M9 30.5C9 28.2909 10.7909 26.5 13 26.5H107C109.209 26.5 111 28.2909 111 30.5V36.5H9V30.5ZM9 45.5H111V90.5C111 92.7091 109.209 94.5 107 94.5H13C10.7909 94.5 9 92.7091 9 90.5V45.5ZM89.5 76.5C87.0147 76.5 85 78.5147 85 81C85 83.4853 87.0147 85.5 89.5 85.5H98.5C100.985 85.5 103 83.4853 103 81C103 78.5147 100.985 76.5 98.5 76.5H89.5Z"
    fill="#E8E8E8"
  />
</svg>
